import { connect } from 'react-redux';
import {
    onEmpDashboard,
    onOrgSurveyDashboard,
    onOrgSurveyCompareDashboard,
    showOrgLoader,
    onOrgDashboard,
    fetchOrgs,
    fetchOrg,
    fetchOrgStatistics,
    fetchOrgsAndSelectOrg,
} from 'actions/Organisation';
import {
    onProjectPrioritiesDashboard,
    onProjectCostPrioritiesDashboard,
    onProjectBusinessPrioritiesDashboard,
    fetchProjects,
} from 'actions/project';
import Component from './Component';

const mapStateToProps = ({ orgs, projects }) => {
    const {
        loader,
        alertMessage,
        showMessage,
        selectedOrg,
        orgDashboardData,
        orgStatisticsData,
    } = orgs;
    const {
        projectList,
    } = projects;
    return {
        loader,
        alertMessage,
        showMessage,
        selectedOrg,
        orgDashboardData,
        projectList,
        orgStatisticsData,
    };
};
export default connect(mapStateToProps,
    {
        onEmpDashboard,
        onOrgSurveyDashboard,
        onOrgSurveyCompareDashboard,
        showOrgLoader,
        fetchOrgs,
        fetchOrg,
        fetchOrgsAndSelectOrg,
        onOrgDashboard,
        fetchProjects,
        onProjectPrioritiesDashboard,
        onProjectCostPrioritiesDashboard,
        onProjectBusinessPrioritiesDashboard,
        fetchOrgStatistics,
    })(Component);


// WEBPACK FOOTER //
// ./components/Agile/OrgDashboard/Container.js